import { ERecipientTypeEnum } from '../enums/recipient-type.enum';
import { EUserType } from '../enums/user-type.enum';

export interface IAuthEngineHttpBaseResponse<T> {
  status: boolean;
  message: string;
  responseCode: string;
  timestamp: string;
  data: T;
}


export interface KeycloakConfig {
  url: string;
  realm: string;
  clientId: string;
  redirectUri: string;
}

export interface IActivateAgent {
  oneTimePasswordToken: string;
  newPassword: string;
  clientId: string;
}

export interface IAccountActivationResponse {
  message: string;
}

export interface ICheckAccountActivationOtpResponseData {
  id: string,
  userId: string,
  type: string,
  status: boolean,
  createdAt: string
  expiresAt: string
}

export interface IResetPass {
  clientId: string;
  usernameType: ERecipientTypeEnum | string;
  username: string;
}

export interface IAccountActivationRequest {
  oneTimePasswordToken: string;
  password: string;
  clientId: string;
  userType: EUserType;
}

export interface IResendActivationTokenRequestByExpiredToken {
  token: string;
  clientId: string;
  userType: EUserType;
}

export interface IResendActivationTokenRequest {
  username: string;
  usernameType: ERecipientTypeEnum;
  clientId: string;
  userType: EUserType;
}

export interface IResendActivationTokenResponseData {
  state: boolean,
  recipient: string,
  entityId: string,
  recipientType: ERecipientTypeEnum,
  otp: string,
  expirationDate: string
}

export interface ICheckPasswordResetOtpTokenResponseData {
  userId: string,
  type: string,
  status: true,
}

export interface IRequestPasswordResetTokenRequest {
  username: string;
  clientId: string;
  usernameType: ERecipientTypeEnum;
  userType: EUserType;
}

export interface IRequestPasswordResetTokenResponseData {
  state: boolean,
  recipient: string,
  entityId: string,
  recipientType: ERecipientTypeEnum,
  otp: string,
  expirationDate: string
}


export interface IResetPasswordRequest {
  oneTimePasswordToken: string,
  newPassword: string,
  clientId: string,
  userType: EUserType
}


export interface IResetPasswordResponseData {
  message: string
}
